
export enum TenantSettingGroup {
  GeneralSettings = 'general.setting',
  Operations = 'operations',
  Recommendations = 'recommendations',
}

export enum TenantSettingKey {
  GeneralSetting = 'general.setting',
  OperationsMaximumRecords = 'operations.max.records',
  XeroConsumerKey = 'accounting.xero.consumer.key',
  XeroConsumerSecret = 'accounting.xero.consumer.secret',
  ExcludeFromRecommendations = 'recommendations.exclude',
  RecommendationLimit = 'recommendations.limit',
  Search = 'search',
  SchedulerEnableSubContractors = 'scheduler_enable_subcontractors',
  TenantPlan = 'tenant.plan',
  SaleQuoteSetting = 'sales.quoteSetting',
  EmbedEmailAttachments = 'embed.email.attachments',
  UniversalChangeStreamResumeToken = 'universal.change.stream.resume.token',
  OutlookActivityKind = 'outlook.activity.kind',
  RecurringJobSchedulerBatchSize = 'recurring.job.scheduler.batch.size',
  JobAttributeFilterLastRunDate = 'job.attribute.filter.last.run.date',
  SiteAttributeFilterLastRunDate = 'site.attribute.filter.last.run.date',
  ContactAttributeFilterLastRunDate = 'contact.attribute.filter.last.run.date',
  PersistHomesNSWWebhookSettings = 'persist.homesnsw.webhook.settings',
  TenantSecuritySettings = 'tenant.security.settings',
  TenantSecurityPreventLogin = 'tenant.security.prevent.login',
  IpWhitelist = 'ip.whitelist',
  FeatureFlags = 'feature.flags',
  PublicApiSettings = 'public.api.settings',
  AgentHarnessSettings = 'agent.harness.settings',
  NotificationSettings = 'notification.settings',
  BusinessRuleConfig = 'business.rule.config',
  AISetting = 'ai.setting',
  AITaskValidation = 'ai.task.validation',
  AIBillImport = 'ai.bill.import',
  AIWorkbuddyAgent = 'ai.charmaine',
  AIAgentWorkspace = 'ai.agent.workspace',
  /** Read-only workspace/feature credit balances (v1, no purchase). Not surfaced while the credits UI is parked. */
  UsageCreditsBalances = 'usage.credits.balances',
  /** Tenant-wide AI spend caps (daily/weekly/monthly USD). Editable only via AI Usage Admin (sysadmin). */
  AIUsageLimits = 'ai.usage.limits',
  IntegrationEventCursor = 'integration.event.cursor',
  EnabledCustomModules = 'enabled.custom.modules',
}

/**
 * Identifiers for optional custom modules gated per-tenant via the `EnabledCustomModules` tenant
 * settings allowlist. A tenant only sees a custom module if its identifier is present in that
 * setting's array — avoids a feature flag per module.
 *
 * @see ./custom.modules.md — registry, how to add a module, and how to enable it for a tenant.
 */
export enum CustomModule {
  BifEvents = 'BifEvents',
  //Surfaces the Submit Supplementary Request quick action on a stage. Entitlement only — the action
  //raises an event and whichever integration the tenant runs decides what, if anything, to submit.
  SupplementaryWorks = 'SupplementaryWorks',
  //TEMPORARY (BGIS SIT, Sep 2026). Surfaces the Add Items Without Authority quick action. Its own
  //entry rather than riding SupplementaryWorks because that module is shared with HomesNSW tenants,
  //whose integration has no handler for this event. Delete with the action when the value-threshold
  //rule ships.
  AddItemsWithoutAuthority = 'AddItemsWithoutAuthority',
  //Surfaces the Request Deletion of Items quick action (WBS-12839). Its own entry for the same reason
  //as AddItemsWithoutAuthority: only the BGIS integration handles the event, so HomesNSW tenants on
  //SupplementaryWorks must not see it.
  RequestItemDeletion = 'RequestItemDeletion',
}

export interface TenantSetting {
  _id: TenantSettingKey;
  value: any;
}
